import { useState } from "react";
import cn from "../utils/cn";
import useImages from "../utils/use_images";
import { get_image_url } from "../api";
function Images() {
  const images = useImages();
  const [state, setState] = useState(-1);
  return (
    <div>
      <div className="bg-blue-300 py-4 text-lg font-semibold text-center">
        Images take up space and if we are not using them lets delete them.
      </div>
      <div className="flex flex-wrap gap-4 justify-center pt-8">
        {images.state.map((image) => (
          <div
            className="border-2 rounded-md p-2 relative"
            onClick={() => setState(image)}
          >
            <div className="absolute top-1 right-1 text-lg font-semibold bg-white p-1 rounded-lg">
              {image}
            </div>
            <img
              src={get_image_url(image)}
              alt="..."
              className={cn(
                "object-cover overflow-hidden",
                state === image ? "w-fit h-fit" : "w-56 h-56"
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Images;
